import { css } from "@emotion/react";

import { colors } from "@styles";

export const link = css`
  color: ${colors.white};
`;

export const flag = css`
  float: left;
  margin-right: 0.5rem;
  margin-top: 0.15rem;
`;

export const container = css`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const icon = css`
  margin-left: 0.5rem;
  color: ${colors.white};
`;

export const selectorContainer = css`
  position: absolute;
  margin-top: 0.15rem;
  margin-left: 1.75rem;
  background: ${colors.white};
  padding: 0.5rem 0.75rem 0.5rem 0.75rem;
  border-radius: 0.5rem;
  box-shadow: 0 10px 20px rgb(0 0 0 / 35%);
  li a {
    &:hover {
      text-decoration: underline;
    }
  }
`;
